import { render, staticRenderFns } from "./ads-banner.vue?vue&type=template&id=4352cc06&"
import script from "./ads-banner.vue?vue&type=script&lang=js&"
export * from "./ads-banner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/templates/pages/events/components/ads-banner/ads-banner.vue
// module id = 908
// module chunks = 0